<div class="page races js-page">
  <div class="racespanel">
    <div class="navblock">
      <div></div>
      <calendar [name]="'Start'" [(date)]="GapDate" [format]="'%0D.%0M.%0Y %0h:%0m:%0s'"></calendar>
      <button id="setintervalbtn" class="btn_blue" (click)="Reload()">{{'Apply'|translate }}</button>
    </div>
    <div class="tablewrap">
      <table id="racers" class="gap">
        <tr>
          <th>{{"Group" | translate}}</th>
          <th>{{"Point" | translate}}</th>
          <th>{{"Time" | translate}}</th>
          <th>{{"Distance" | translate}}</th>
          <th>{{"Gap" | translate}}</th>
        </tr>
        <tr *ngFor="let gap of gaps">
          <td>{{gap.ObjectName}}</td>
          <td>{{gap.TrackPoint}}</td>
          <td>{{gap.Time | datetime:'%0D.%0M.%0Y %0h:%0m:%0s'}}</td>
          <td>{{(gap.TrackDist / 1000).toFixed(3)}} {{"km" | localizeUnits}}</td>
          <td>{{gap.TimeGap | time}}</td>
        </tr>
      </table>
    </div>
    <div class="tablenav">
      <app-pagination [viewmode]="'print excel'" [printElementID]="'tablewrap'"></app-pagination>
    </div>
  </div>
</div>

<template #mgmtDialog>
</template>
